/*
 * r16sd: the Settings Doctor's calls, with the API client required on FIRST USE rather than at import time. The app shell (Layout:
 * the account banner and the credits) loads the doctor's modules on every page, and nothing here runs unless the server's doctor
 * is on - so a page or a test that never meets a doctor answer never loads lib/api.js through them (Layout's own tests run without
 * an api mock; axios is an ES module Jest cannot load). A test that mocks lib/api.js gets its mock here too (same module).
 * Every call answers a promise; a client without the route rejects like a 404 would.
 */
let client = null;
function api() {
  if (!client) client = require('./api');
  return client;
}
const missing = (what) => Promise.reject(Object.assign(new Error(`${what} is not available`), { response: { status: 404, data: {} } }));

export function getMe() {
  const a = api().authApi;
  return a && typeof a.getMe === 'function' ? a.getMe() : missing('/me');
}

export function readPanel(slotName) {
  const d = api().doctorApi;
  return d && typeof d.panel === 'function' ? d.panel(slotName) : missing('the doctor panel');
}

export function switchSlotOn(slotName) {
  const s = api().slotsApi;
  return s && typeof s.setEnabled === 'function' ? s.setEnabled(slotName, true) : missing('the slot switch');
}

/** Stage 5: apply one offered fix; the server derives the values (DOCTOR-API 11.2). */
export function applyFix(slotName, rule, fixId) {
  const d = api().doctorApi;
  return d && typeof d.fix === 'function' ? d.fix(slotName, rule, fixId) : missing('the doctor fix');
}

/** Stage 5: "Don't show again" for one rule on one slot, until its settings change (DOCTOR-API 11.3). */
export function dismissRule(slotName, rule) {
  const d = api().doctorApi;
  return d && typeof d.dismiss === 'function' ? d.dismiss(slotName, rule) : missing('the doctor dismiss');
}

export function switchDeviceOn(deviceId) {
  const d = api().devicesApi;
  return d && typeof d.setEnabled === 'function' ? d.setEnabled(deviceId, true) : missing('the device switch');
}
